<template>
  <div>
    <el-radio-group v-model="operator" size="mini" @change="change" onclick="">
      <el-radio-button label="CUCC">中国联通</el-radio-button>
      <el-radio-button label="CMCC">中国移动</el-radio-button>
      <el-radio-button label="CTCC">中国电信</el-radio-button>
      <el-radio-button label="CBN">中国广电</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  data () {
    return {
      operator: ''
    }
  },
  props: ['value', 'config', 'size', 'disabled', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
      this.$parent.getList()
    }
  },
  mounted () {
    this.change(this.operator)
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/OperatorRadio.vue